/* Fixed Chile campaign dates. No URL/session overrides; no catalog/price/stock changes. */
(function(){
  'use strict';
  var START=Date.parse('2026-10-09T23:59:00-03:00');
  var END=Date.parse('2026-10-11T23:59:00-03:00');
  function stateAt(now){
    var phase=now<START?'before':now<END?'final':'ended';
    var total=phase==='final'?Math.max(0,Math.ceil((END-now)/1000)):0;
    return {phase:phase,start:START,end:END,seconds:total,hours:Math.floor(total/3600),minutes:Math.floor(total/60)%60,remainder:total%60};
  }
  if(typeof document==='undefined'){module.exports={stateAt:stateAt,start:START,end:END};return;}
  function boot(){
    if(document.documentElement.hasAttribute('data-cyber-restored'))return;
    if(!document.getElementById('cfc-console-template')||document.documentElement.classList.contains('cf-preview'))return;
    if(document.documentElement.hasAttribute('data-cfc-scheduled'))return;
    document.documentElement.setAttribute('data-cfc-scheduled','');
    var localQA=/^(localhost|127\.0\.0\.1)$/.test(location.hostname)&&document.documentElement.getAttribute('data-cmomo-preview-now');
    var simulated=localQA?Date.parse(localQA):NaN,loadedAt=Date.now();
    function now(){return Number.isFinite(simulated)?simulated+(Date.now()-loadedAt):Date.now();}
    var root,panel,titleHost,home,mounted=false,phase=null,ticker=null,observer,productTrail;
    var reduced=matchMedia('(prefers-reduced-motion: reduce)'),paused=false,inView=true;
    function paintMotion(){
      if(!panel)return;
      var scene=panel.querySelector('.cr-scene'),ended=phase==='ended';
      scene.toggleAttribute('data-cr-paused',paused||reduced.matches||ended);
      scene.toggleAttribute('data-cr-hidden',document.hidden||!inView);
      scene.disabled=reduced.matches||ended;
      scene.setAttribute('aria-label',ended?'Momo: gracias por acompañarnos':paused?'Reanudar animación de Momo':'Pausar animación de Momo');
      scene.querySelector('.cr-control').textContent=ended?'':reduced.matches?'¡¡APROVECHEN!!':paused?'▶ Seguir corriendo':'Ⅱ Pausar a Momo';
      if(productTrail){productTrail.setActive(!paused&&!reduced.matches&&!ended&&!document.hidden&&inView);if(ended)productTrail.clear();}
    }
    function mount(){
      root=document.querySelector('.sp4c-chero.sp4c-cneon')||document.querySelector('[data-cyber-lab]');
      if(!root)return false;
      home=root.classList.contains('sp4c-cneon');
      titleHost=root.querySelector(home?'.sp4c-cneon__copy':'.sp4c-coll__title-wrap');
      var host=root.querySelector(home?'.sp4c-cneon__action':'.sp4c-coll__header > .sp4c-coll__inner');
      if(!titleHost||!host)return false;
      panel=document.getElementById('cfc-console-template').content.firstElementChild.cloneNode(true);
      // The collection renders the campaign snippet inside titleHost. Keep its
      // stylesheet connected when replacing that wrapper's original contents.
      titleHost.querySelectorAll('link[rel="stylesheet"][href*="cyber-final-campaign.css"]').forEach(function(link){
        document.head.appendChild(link);
      });
      titleHost.replaceChildren(document.getElementById('cfc-title-template').content.cloneNode(true));
      titleHost.setAttribute('data-cf-ready','');
      if(home){
        host.replaceChildren(panel,document.getElementById('cfc-cta-template').content.cloneNode(true));
        host.setAttribute('data-cf-ready','');
        var all=root.querySelector('.sp4c-cneon__deals-head a');if(all)all.href='/collections/cyber';
      }else{panel.classList.add('cf-console--collection');host.appendChild(panel);}
      root.setAttribute('data-cf-campaign','final');
      root.removeAttribute('data-cyber-visible');
      document.dispatchEvent(new CustomEvent('cyber:final:activated'));
      document.querySelectorAll('.cmomo-console,.cmomo-sticky,.cyber-lab-momo,.cyber-finale-lab-label,.cyber-panda-dock,.cyber-power-trace').forEach(function(el){el.remove();});
      document.documentElement.classList.add('cf-campaign','cr-campaign');
      if(window.SoyMomoRunnerDrops)productTrail=window.SoyMomoRunnerDrops.mount(panel.querySelector('.cr-scene'));
      panel.querySelector('.cr-scene').addEventListener('click',function(){paused=!paused;paintMotion();});
      if('IntersectionObserver' in window){
        observer=new IntersectionObserver(function(entries){inView=entries[0].isIntersecting;paintMotion();});
        observer.observe(panel);
      }
      mounted=true;return true;
    }
    function applyPhase(state){
      phase=state.phase;root.setAttribute('data-cf-campaign',phase);root.setAttribute('data-cmomo-phase',phase);
      var ended=phase==='ended',marquee=root.querySelector('.sp4c-cneon__track');
      if(marquee)marquee.innerHTML=ended?'<span>GRACIAS POR ACOMPAÑARNOS</span><span class="hot">TECNOLOGÍA PARA TU FAMILIA</span>':'<span>¡¡APROVECHEN!!</span><span class="hot">EXTENSIÓN FINAL</span><span>HASTA EL DOMINGO · 23:59</span><span class="hot">CYBER SOYMOMO</span>';
      if(ended){
        titleHost.querySelector('.cf-kicker').textContent='CYBER FINALIZADO';
        var title=titleHost.querySelector('.cf-title');title.innerHTML='<span>GRACIAS</span> <span>POR VENIR</span>';title.setAttribute('aria-label','Gracias por venir');
        titleHost.querySelector('.cf-tagline').textContent='Nos vemos en la próxima.';
        titleHost.querySelector('.cf-deadline-copy').textContent='Esta edición del Cyber terminó.';
        panel.querySelector('.cf-clock-caption').textContent='EL CYBER TERMINÓ';
        panel.querySelector('.cf-clock-date').textContent='Domingo 11 oct. · 23:59 h Chile';
        panel.querySelector('.cr-bubble text').textContent='¡GRACIAS!';
        var cta=root.querySelector('.cf-cta');if(cta){cta.textContent='Ver productos →';cta.href='/collections/all';}
        var all=root.querySelector('.sp4c-cneon__deals-head a');if(all){all.textContent='Ver productos →';all.href='/collections/all';}
        root.querySelectorAll('.sp4c-cneon-card__off').forEach(function(el){el.textContent=el.textContent.replace(/CYBER\s*/gi,'');});
      }
      panel.querySelector('.cfc-announcement').textContent=ended?'El Cyber ha finalizado. Gracias por acompañarnos.':'Última extensión del Cyber: hasta el domingo 11 de octubre a las 23:59, hora de Chile.';
      paintMotion();
    }
    function pad(value){return String(value).padStart(2,'0');}
    function tick(){
      var state=stateAt(now());
      if(state.phase==='ended'&&window.SoyMomoCyberReturn&&window.SoyMomoCyberReturn.restore())return;
      if(document.documentElement.hasAttribute('data-cyber-restored'))return;
      if(state.phase==='before')return;
      if(!mounted&&!mount())return;
      if(state.phase!==phase)applyPhase(state);
      panel.querySelector('[data-cf-h]').textContent=pad(state.hours);
      panel.querySelector('[data-cf-m]').textContent=pad(state.minutes);
      panel.querySelector('[data-cf-s]').textContent=pad(state.remainder);
      panel.querySelector('.cf-digits').setAttribute('aria-label',state.hours+' horas, '+state.minutes+' minutos y '+state.remainder+' segundos restantes');
    }
    tick();ticker=setInterval(tick,1000);
    document.addEventListener('cyber:closed',function(){clearInterval(ticker);ticker=null;if(productTrail){productTrail.setActive(false);productTrail.clear();}if(observer)observer.disconnect();});
    document.addEventListener('visibilitychange',function(){tick();paintMotion();});
    reduced.addEventListener('change',paintMotion);
    window.addEventListener('pagehide',function(){clearInterval(ticker);ticker=null;});
    window.addEventListener('pageshow',function(){tick();if(!ticker)ticker=setInterval(tick,1000);});
  }
  // Let all earlier theme handlers initialize first; old countdown yields ownership at activation.
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){setTimeout(boot,0);});else setTimeout(boot,0);
})();
